import _extends from "@babel/runtime-corejs3/helpers/extends";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import { features } from '@kdcloudjs/table';

function useSort(pipeline, sort) {
  if (sort) {
    pipeline.use(_sortInstanceProperty(features).call(features, _extends({}, sort)));
  }
}

export default useSort;